import type { GrantTypeOption } from '../types/identityProvider';

export const grantTypeOptions: GrantTypeOption[] = [
    { label: 'Authorization Code', value: 'AuthorizationCode' },
    { label: 'Client Credentials', value: 'ClientCredentials' },
];
